export const GETDROPDOWNSURL = process.env.REACT_APP_DATABASE_URL + "/dropdowns/" ;
export const GETDROPDOWNURL = process.env.REACT_APP_DATABASE_URL + "/dropdown/" ;



/*** FORM CONSTANTS - START */
  export const BOP_LEVEL_OF_SECURITY = [
    { value: "1", label: "MINIMUM" },
    { value: "2", label: "LOW" },
    { value: "3", label: "MEDIUM" },
    { value: "4", label: "HIGH" },
  ];
  export const CROSSPOINT_BEHAVIORAL_HEALTH_SERVICES = [
    { value: "1", label: "NONE" },
    { value: "2", label: "INDIVIDUAL" },
    { value: "3", label: "GROUP" },
    { value: "4", label: "BOTH" },
  ];
  export const HEALTH_DIAGNOSIS = [
    { value: "1", label: "UNKNOWN" },
    { value: "2", label: "ADHD" },
    { value: "3", label: "ADJUSTMENT DISORDER" },
    { value: "4", label: "ANXIETY" },
    { value: "5", label: "BIPOLAR" },
    { value: "6", label: "MAJOR DEPRESSION" },
    { value: "7", label: "PERSONALITY DISORDER" },
    { value: "8", label: "PTSD" },
    { value: "9", label: "SCHIZOAFFECTIVE" },
    { value: "10", label: "SCHIZOPHRENIA" },
    { value: "11", label: "SUBSTANCE USE" },
    { value: "12", label: "OTHER" },
  ];
  export const CLIENT_BEHAVIORAL_HEALTH_PROGRAMS_DURING_PROGRAM_STAY = [
    { value: "1", label: "N / A" },
    { value: "2", label: "Co-Occurring Disorder" },
    { value: "3", label: "Mental Health" },
    { value: "4", label: "Substance Use Disorder" },
  ];
  export const CLIENT_DISCHARGE_STATUS = [
    { value: "1", label: "PENDING" },
    { value: "2", label: "SUCCESSFUL" },
    { value: "3", label: "UnSUCCESSFUL" },
    { value: "4", label: "NEUTRAL" },
  ];
  export const CLIENT_EMPLOYED_AT_DISCHARGE = [
    { value: "1", label: "UNKNOWN" },
    { value: "2", label: "NOT PROVIDED" },
    { value: "3", label: "FULL TIME" },
    { value: "4", label: "PART TIME" },
    { value: "5", label: "WAIVER / DISABLED" },
    { value: "6", label: "UNEMPLOYED" },
    { value: "7", label: "RETIREMENT / DISABILITY INCOME" },
  ];
  export const CLIENT_HOUSING_AT_DISCHARGE = [
    { value: "1", label: "UNKNOWN" },
    { value: "2", label: "NOT PROVIDED" },
    { value: "3", label: "DEPENDANT AND STABLE" },
    { value: "4", label: "INDEPENDANT AND STABLE" },
    { value: "5", label: "SUPPORTIVE HOUSING (EG SOBER LIVING)" },
    { value: "6", label: "HOMELESS OR UNSTABLE" },
    { value: "7", label: "SHELTER" },
    { value: "8", label: "INSTITUTION" },
    { value: "9", label: "HOSPITAL" },
  ];
  export const CLIENT_BENEFIT_APPLICATION_INITIATED = [
    { value: "1", label: "N / A" },
    { value: "2", label: "YES" },
    { value: "3", label: "NO" },
    { value: "4", label: "IN PROGRESS" },
    { value: "5", label: "REFUSED" },
  ];
  export const CURRENT_INSTANT_OFFENSE_LIST = [
    { value: 1, label: "NONE" },
    { value: 2, label: "VIOLENT" },
    { value: 3, label: "DRUG SALES, IMPORT, MANUFACTURER" },
    { value: 4, label: "FIREARMS" },
    { value: 5, label: "WHITE COLLAR" },
    { value: 6, label: "OTHER UTILITARIAN ACT OR CRIME FOR PERSONAL OR MATERIAL GAIN" },
    { value: 7, label: "OTHER" },
    { value: 8, label: "UNKNOWN" },
  ];
  export const CLIENT_IDENTIFIED_SEXUAL_ORIENTATION = [
    { value: "1", label: "HETERO" },
    { value: "2", label: "GAY" },
    { value: "3", label: "LESBIAN" },
    { value: "4", label: "BISEXUAL" },
    { value: "5", label: "GENDER NONCONFORMING" },
  ];
  export const CLIENT_RECIDIVISM_RISK_SCORE_LEVEL = [
    { value: "1", label: "DOES NOT APPLY" },
    { value: "2", label: "NOT ADMINISTERED" },
    { value: "3", label: "LOW" },
    { value: "4", label: "MODERATE" },
    { value: "5", label: "HIGH" },
    { value: "6", label: "VERY HIGH" },
  ];
  export const CLIENT_SOURCE_OF_INCOME = [
    { value: "1", label: "NONE" },
    { value: "2", label: "EARNED INCOME" },
    { value: "3", label: "DISABILITY" },
    { value: "4", label: "RETIREMENT / PENSION" },
    { value: "5", label: "OTHER" },
  ];
  export const EDUCATION_COMPLETED = [
    { value: "1", label: "DID NOT GRADUATE HS" },
    { value: "2", label: "GED OR HS DIPLOMA" },
    { value: "3", label: "SOME COLLEGE OR VOCATIONAL TRAINING" },
    { value: "4", label: "ASSOCIATE'S DEGREE OR VOCATIONAL CERTIFICATE" },
    { value: "5", label: "BACHELOR'S DEGREE" },
    { value: "6", label: "COLLEGE BEYOND BACHELOR'S DEGREE" },
  ];
  export const ETHNICITY_LIST = [
    { value: "1", label: "WHITE" },
    { value: "2", label: "BLACK / AFRICAN AMERICAN" },
    { value: "3", label: "HISPANIC" },
    { value: "4", label: "NATIVE AMERICAN" },
    { value: "5", label: "ASIAN / PACIFIC ISLANDER" },
    { value: "6", label: "BIRACIAL" },
    { value: "7", label: "OTHER" },
  ];
  export const GENDER_LIST = [
    { value: "1", label: "MALE" },
    { value: "2", label: "FEMALE" },
    { value: "3", label: "TRANSGENDER (MALE)" },
    { value: "4", label: "TRANSGENDER (FEMALE)" },
    { value: "5", label: "INTERSEX" },
  ];
  export const RECEIVING_BEHAVIORAL_HEALTH_SERVICES = [
    { value: "1", label: "NONE" },
    { value: "2", label: "COMMUNITY" },
    { value: "3", label: "CROSSPOINT" },
    { value: "4", label: "BOTH" },
  ];
  export const RESIDENT_WITH_DISABILITIES = [
    { value: "1", label: "NONE" },
    { value: "2", label: "PHYSICAL DISABILITY (MOBILITY, E.G.)" },
    { value: "3", label: "BLIND" },
    { value: "4", label: "DEAF" },
    { value: "5", label: "HARD OF HEARING" },
    { value: "6", label: "COGNITIVE DISABILITY" },
  ];
  export const SUPPORT_SYSTEM = [
    { value: "1", label: "UNKNOWN" },
    { value: "2", label: "FAMILY" },
    { value: "3", label: "OTHER" },
    { value: "4", label: "NO" },
  ];
  export const EDUCATION_ACHIEVEMENT_OR_CHANGES = [
    { value: "1", label: "NO" },
    { value: "2", label: "YES - COMPLETED HS / GED" },
    { value: "3", label: "YES - ATTENDED COLLEGE OR VOCATIONAL TRAINING" },
    { value: "4", label: "COMPLETED - COLLEGE OR VOCATIONAL TRAINING" },
    { value: "5", label: "REFUSED TO ANSWER" },
  ];
  export const FAMILY_AND_SIGNIFICANT_OTHERS = [
    { value: "1", label: "NO CHANGES SINCE DISCHARGE" },
    { value: "2", label: "REUNIFIED WITH SPOUSE / SIG OTHER" },
    { value: "3", label: "REUNIFIED WITH CHILDREN" },
    { value: "4", label: "RELATIONSHIPS UNSTABLE OR UNSUCCESSFUL" },
    { value: "5", label: "REFUSED TO ANSWER" },
  ];
  export const ATTEMPTED_CONTACT_RESULTS = [
    { value: "1", label: "REFUSED TO ANSWER" },
    { value: "2", label: "NOT PROVIDED" },
    { value: "3", label: "DEPENDANT AND STABLE" },
    { value: "4", label: "INDEPENDANT AND STABLE" },
    { value: "5", label: "SUPPORTIVE HOUSING (EG SOBER LIVING)" },
    { value: "6", label: "HOMELESS OR UNSTABLE" },
    { value: "7", label: "SHELTER" },
    { value: "8", label: "INSTITUTION" },
    { value: "9", label: "HOSPITAL" },
    { value: "10", label: "NO FURTHER CONTACT" },
  ];
  export const ATTEMPTED_CONTACT_EMPLOYED_STATUS_RESULTS = [
    { value: "1", label: "REFUSED TO ANSWER" },
    { value: "2", label: "FULL TIME" },
    { value: "3", label: "PART TIME" },
    { value: "4", label: "WAIVER / DISABLED" },
    { value: "5", label: "UNEMPLOYED" },
    { value: "6", label: "RETIREMENT / DISABILITY INCOME" },
    { value: "7", label: "RETIRED / DISABLED NO INCOME" },
    { value: "8", label: "NONE, ATTENDING SCHOOL" },
  ];
  export const POST_DISCHARGE_SUBSTANCE_USE = [
    { value: "1", label: "REFUSED TO ANSWER" },
    { value: "2", label: "NO USE" },
    { value: "3", label: "ALCOHOL ONLY" },
    { value: "4", label: "OTHER DRUGS" },
    // {value: '5', label: "NO FURTHER CONTACT"}
  ];
  export const POST_DISCHARGE_RATE_QUALITY_OF_LIFE = [
    { value: "1", label: "REFUSED TO ANSWER" },
    { value: "2", label: "GOOD OR GREAT" },
    { value: "3", label: "SATISFACTORY" },
    { value: "4", label: "UNSATISFACTORY" },
    { value: "5", label: "TERRIBLE OR MISERABLE" },
  ];
  export const NA_YES_NO = [
    { value: "1", label: "N / A" },
    { value: "2", label: "YES" },
    { value: "3", label: "NO" },
  ];
  export const NO_YES = [
    { value: "1", label: "NO" },
    { value: "2", label: "YES" },
  ];
  export const UNKNOWN_YES_NO = [
    { value: "1", label: "UNKNOWN" },
    { value: "2", label: "YES" },
    { value: "3", label: "NO" },
  ];
  export const HOW_MANY_MONTHS_IN_PAST_YEAR = [
    { value: "1", label: "UNKOWN" },
    { value: "2", label: "NEVER" },
    { value: "3", label: "LESS THAN 1 MONTH" },
    { value: "4", label: "1 TO 3 MONTHS" },
    { value: "5", label: "3 TO 6 MONTHS" },
    { value: "6", label: "6 MONTHS OR MORE" },
  ];

  export const buildOptions_NumberOfChildren = () => {
    var options = [];
    for (let i = 0; i <= 14; i++) {
      options.push({
        value: "" + i,
        label: "" + i,
      });
    }
    options.push({
      value: "15",
      label: "15 OR MORE",
    });
    return options;
  };
    
    
/*** FORM CONSTANTS - END */



/* REPORTS */
export const REPORT_ALLTABLES_COUNT = 'REPORT_ALLTABLESCOUNT';
export const GET_REPORT_ALLTABLES_COUNT = 'GET_REPORT_ALLTABLES_COUNT';
export const GET_REPORT_ALLTABLES_COUNT_PENDING = 'GET_REPORT_ALLTABLES_COUNT_PENDING';
export const GET_REPORT_ALLTABLES_COUNT_FULFILLED = 'GET_REPORT_ALLTABLES_COUNT_FULFILLED';
export const GET_REPORT_ALLTABLES_COUNT_REJECTED = 'GET_REPORT_ALLTABLES_COUNT_REJECTED';









/*** Error Message */
export const ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED = "You have no programs to show. Please get with your admin to give you program access.";

/*** GLOBAL */
export const GET_DASHBOARD_COUNTS = 'GET_DASHBOARD_COUNTS';
export const GET_DASHBOARD_COUNTS_PENDING = 'GET_DASHBOARD_COUNTS_PENDING';
export const GET_DASHBOARD_COUNTS_FULFILLED = 'GET_DASHBOARD_COUNTS_FULFILLED';
export const GET_DASHBOARD_COUNTS_REJECTED = 'GET_DASHBOARD_COUNTS_REJECTED';
export const GET_DASHBOARD_COUNTS_SUCCESS = 'GET_DASHBOARD_COUNTS_SUCCESS';



/*** REPORTS GLOBALS */
export const GET_REPORTS_DASHBOARD_COUNTS = 'GET_REPORTS_DASHBOARD_COUNTS';
export const GET_REPORTS_DASHBOARD_COUNTS_PENDING = 'GET_REPORTS_DASHBOARD_COUNTS_PENDING';
export const GET_REPORTS_DASHBOARD_COUNTS_FULFILLED = 'GET_REPORTS_DASHBOARD_COUNTS_FULFILLED';
export const GET_REPORTS_DASHBOARD_COUNTS_REJECTED = 'GET_REPORTS_DASHBOARD_COUNTS_REJECTED';
export const GET_REPORTS_DASHBOARD_COUNTS_SUCCESS = 'GET_REPORTS_DASHBOARD_COUNTS_SUCCESS';

export const GET_REPORTS_PROGRAMS_COUNTS = 'GET_REPORTS_PROGRAMS_COUNTS';
export const GET_REPORTS_PROGRAMS_COUNTS_PENDING = 'GET_REPORTS_PROGRAMS_COUNTS_PENDING';
export const GET_REPORTS_PROGRAMS_COUNTS_FULFILLED = 'GET_REPORTS_PROGRAMS_COUNTS_FULFILLED';
export const GET_REPORTS_PROGRAMS_COUNTS_REJECTED = 'GET_REPORTS_PROGRAMS_COUNTS_REJECTED';



/* ARCHIVED referral */
export const GET_ARCHIVED_REFERRALS_PENDING_LIST_FULFILLED = 'GET_ARCHIVED_REFERRALS_PENDING_LIST_FULFILLED';

export const GET_ARCHIVED_REFERRALS_COUNT = 'GET_ARCHIVED_REFERRALS_COUNT';
export const GET_ARCHIVED_REFERRALS_COUNT_PENDING = 'GET_ARCHIVED_REFERRALS_COUNT_PENDING';
export const GET_ARCHIVED_REFERRALS_COUNT_FULFILLED = 'GET_ARCHIVED_REFERRALS_COUNT_FULFILLED';
export const GET_ARCHIVED_REFERRALS_COUNT_REJECTED = 'GET_ARCHIVED_REFERRALS_COUNT_REJECTED';

export const GET_ARCHIVED_REFERRAL = 'GET_ARCHIVED_REFERRAL';
export const GET_ARCHIVED_REFERRAL_PENDING = 'GET_ARCHIVED_REFERRAL_PENDING';
export const GET_ARCHIVED_REFERRAL_FULFILLED = 'GET_ARCHIVED_REFERRAL_FULFILLED';
export const GET_ARCHIVED_REFERRAL_REJECTED = 'GET_ARCHIVED_REFERRAL_REJECTED';

export const GET_ARCHIVED_REFERRALS_LIST = 'GET_ARCHIVED_REFERRALS_LIST';
export const GET_ARCHIVED_REFERRALS_LIST_PENDING = 'GET_ARCHIVED_REFERRALS_LIST_PENDING';
export const GET_ARCHIVED_REFERRALS_LIST_FULFILLED = 'GET_ARCHIVED_REFERRALS_LIST_FULFILLED';
export const GET_ARCHIVED_REFERRALS_LIST_REJECTED = 'GET_ARCHIVED_REFERRALS_LIST_REJECTED';

/* ARCHIVED client */
export const GET_ARCHIVED_CLIENTS_COUNT = 'GET_ARCHIVED_CLIENTS_COUNT';
export const GET_ARCHIVED_CLIENTS_COUNT_PENDING = 'GET_ARCHIVED_CLIENTS_COUNT_PENDING';
export const GET_ARCHIVED_CLIENTS_COUNT_FULFILLED = 'GET_ARCHIVED_CLIENTS_COUNT_FULFILLED';
export const GET_ARCHIVED_CLIENTS_COUNT_REJECTED = 'GET_ARCHIVED_CLIENTS_COUNT_REJECTED';

export const GET_ARCHIVED_CLIENTS_LIST = 'GET_ARCHIVED_CLIENTS_LIST';
export const GET_ARCHIVED_CLIENTS_LIST_PENDING = 'GET_ARCHIVED_CLIENTS_LIST_PENDING';
export const GET_ARCHIVED_CLIENTS_LIST_FULFILLED = 'GET_ARCHIVED_CLIENTS_LIST_FULFILLED';
export const GET_ARCHIVED_CLIENTS_LIST_REJECTED = 'GET_ARCHIVED_CLIENTS_LIST_REJECTED';

/* ARCHIVED postdischarge */
export const GET_ARCHIVED_POSTDISCHARGES_COUNT = 'GET_ARCHIVED_POSTDISCHARGES_COUNT';
export const GET_ARCHIVED_POSTDISCHARGES_COUNT_PENDING = 'GET_ARCHIVED_POSTDISCHARGES_COUNT_PENDING';
export const GET_ARCHIVED_POSTDISCHARGES_COUNT_FULFILLED = 'GET_ARCHIVED_POSTDISCHARGES_COUNT_FULFILLED';
export const GET_ARCHIVED_POSTDISCHARGES_COUNT_REJECTED = 'GET_ARCHIVED_POSTDISCHARGES_COUNT_REJECTED';

export const GET_ARCHIVED_POSTDISCHARGES_LIST = 'GET_ARCHIVED_POSTDISCHARGES_LIST';
export const GET_ARCHIVED_POSTDISCHARGES_LIST_PENDING = 'GET_ARCHIVED_POSTDISCHARGES_LIST_PENDING';
export const GET_ARCHIVED_POSTDISCHARGES_LIST_FULFILLED = 'GET_ARCHIVED_POSTDISCHARGES_LIST_FULFILLED';
export const GET_ARCHIVED_POSTDISCHARGES_LIST_REJECTED = 'GET_ARCHIVED_POSTDISCHARGES_LIST_REJECTED';


/* referral */
export const GET_REFERRAL = 'GET_REFERRAL';
export const GET_REFERRAL_PENDING = 'GET_REFERRAL_PENDING';
export const GET_REFERRAL_FULFILLED = 'GET_REFERRAL_FULFILLED';
export const GET_REFERRAL_REJECTED = 'GET_REFERRAL_REJECTED';

export const GET_REFERRALS_COUNT = 'GET_REFERRALS_COUNT';
export const GET_REFERRALS_COUNT_PENDING = 'GET_REFERRALS_COUNT_PENDING';
export const GET_REFERRALS_COUNT_FULFILLED = 'GET_REFERRALS_COUNT_FULFILLED';
export const GET_REFERRALS_COUNT_REJECTED = 'GET_REFERRALS_COUNT_REJECTED';

export const GET_REFERRALS_LIST = 'GET_REFERRALS_LIST';
export const GET_REFERRALS_LIST_PENDING = 'GET_REFERRALS_LIST_PENDING';
export const GET_REFERRALS_LIST_FULFILLED = 'GET_REFERRALS_LIST_FULFILLED';
export const GET_REFERRALS_LIST_REJECTED = 'GET_REFERRALS_LIST_REJECTED';

export const GET_REFERRALS_PENDING_LIST = 'GET_REFERRALS_PENDING_LIST';
export const GET_REFERRALS_PENDING_LIST_PENDING = 'GET_REFERRALS_PENDING_LIST_PENDING';
export const GET_REFERRALS_PENDING_LIST_FULFILLED = 'GET_REFERRALS_PENDING_LIST_FULFILLED';
export const GET_REFERRALS_PENDING_LIST_REJECTED = 'GET_REFERRALS_PENDING_LIST_REJECTED';

export const TRANSFER_REFERRAL = 'TRANSFER_REFERRAL';
export const TRANSFER_REFERRAL_PENDING = 'TRANSFER_REFERRAL_PENDING';
export const TRANSFER_REFERRAL_FULFILLED = 'TRANSFER_REFERRAL_FULFILLED';
export const TRANSFER_REFERRAL_REJECTED = 'TRANSFER_REFERRAL_REJECTED';

export const ARCHIVE_REFERRAL = 'ARCHIVE_REFERRAL';
export const ARCHIVE_REFERRAL_PENDING = 'ARCHIVE_REFERRAL_PENDING';
export const ARCHIVE_REFERRAL_FULFILLED = 'ARCHIVE_REFERRAL_FULFILLED';
export const ARCHIVE_REFERRAL_REJECTED = 'ARCHIVE_REFERRAL_REJECTED';

export const DELETE_REFERRAL = 'DELETE_REFERRAL';
export const DELETE_REFERRAL_PENDING = 'DELETE_REFERRAL_PENDING';
export const DELETE_REFERRAL_FULFILLED = 'DELETE_REFERRAL_FULFILLED';
export const DELETE_REFERRAL_REJECTED = 'DELETE_REFERRAL_REJECTED';

export const CREATE_NEW_REFERRAL = 'CREATE_NEW_REFERRAL';

export const ADD_REFERRAL = 'ADD_REFERRAL';
export const ADD_REFERRAL_PENDING = 'ADD_REFERRAL_PENDING';
export const ADD_REFERRAL_FULFILLED = 'ADD_REFERRAL_FULFILLED';
export const ADD_REFERRAL_REJECTED = 'ADD_REFERRAL_REJECTED';

export const UPDATE_REFERRAL_SAVE = 'UPDATE_REFERRAL_SAVE';
export const UPDATE_REFERRAL_SAVE_PENDING = 'UPDATE_REFERRAL_SAVE_PENDING';
export const UPDATE_REFERRAL_SAVE_FULFILLED = 'UPDATE_REFERRAL_SAVE_FULFILLED';
export const UPDATE_REFERRAL_SAVE_REJECTED = 'UPDATE_REFERRAL_SAVE_REJECTED';

export const UPDATE_REFERRAL_SAVE_AND_CLOSE = 'UPDATE_REFERRAL_SAVE_AND_CLOSE';
export const UPDATE_REFERRAL_SAVE_AND_CLOSE_PENDING = 'UPDATE_REFERRAL_SAVE_AND_CLOSE_PENDING';
export const UPDATE_REFERRAL_SAVE_AND_CLOSE_FULFILLED = 'UPDATE_REFERRAL_SAVE_AND_CLOSE_FULFILLED';
export const UPDATE_REFERRAL_SAVE_AND_CLOSE_REJECTED = 'UPDATE_REFERRAL_SAVE_AND_CLOSE_REJECTED';


/* client */
export const GET_CLIENTS_COUNT = 'GET_CLIENTS_COUNT';
export const GET_CLIENTS_COUNT_PENDING = 'GET_CLIENTS_COUNT_PENDING';
export const GET_CLIENTS_COUNT_FULFILLED = 'GET_CLIENTS_COUNT_FULFILLED';
export const GET_CLIENTS_COUNT_REJECTED = 'GET_CLIENTS_COUNT_REJECTED';

export const GET_CLIENT = 'GET_CLIENT';
export const GET_CLIENT_PENDING = 'GET_CLIENT_PENDING';
export const GET_CLIENT_FULFILLED = 'GET_CLIENT_FULFILLED';
export const GET_CLIENT_REJECTED = 'GET_CLIENT_REJECTED';

export const GET_CLIENTS_LIST = 'GET_CLIENTS_LIST';
export const GET_CLIENTS_LIST_PENDING = 'GET_CLIENTS_LIST_PENDING';
export const GET_CLIENTS_LIST_FULFILLED = 'GET_CLIENTS_LIST_FULFILLED';
export const GET_CLIENTS_LIST_REJECTED = 'GET_CLIENTS_LIST_REJECTED';

export const UPDATE_CLIENT_SAVE = 'UPDATE_CLIENT_SAVE';
export const UPDATE_CLIENT_SAVE_PENDING = 'UPDATE_CLIENT_SAVE_PENDING';
export const UPDATE_CLIENT_SAVE_FULFILLED = 'UPDATE_CLIENT_SAVE_FULFILLED';
export const UPDATE_CLIENT_SAVE_REJECTED = 'UPDATE_CLIENT_SAVE_REJECTED';

export const UPDATE_CLIENT_SAVE_AND_CLOSE = 'UPDATE_CLIENT_SAVE_AND_CLOSE';
export const UPDATE_CLIENT_SAVE_AND_CLOSE_PENDING = 'UPDATE_CLIENT_SAVE_AND_CLOSE_PENDING';
export const UPDATE_CLIENT_SAVE_AND_CLOSE_FULFILLED = 'UPDATE_CLIENT_SAVE_AND_CLOSE_FULFILLED';
export const UPDATE_CLIENT_SAVE_AND_CLOSE_REJECTED = 'UPDATE_CLIENT_SAVE_AND_CLOSE_REJECTED';

export const CLIENT_CHANGE_PROGRAM = 'CLIENT_CHANGE_PROGRAM';
export const CLIENT_CHANGE_PROGRAM_PENDING = 'CLIENT_CHANGE_PROGRAM_PENDING';
export const CLIENT_CHANGE_PROGRAM_FULFILLED = 'CLIENT_CHANGE_PROGRAM_FULFILLED';
export const CLIENT_CHANGE_PROGRAM_REJECTED = 'CLIENT_CHANGE_PROGRAM_REJECTED';

export const TRANSFER_CLIENT = 'TRANSFER_CLIENT';
export const TRANSFER_CLIENT_PENDING = 'TRANSFER_CLIENT_PENDING';
export const TRANSFER_CLIENT_FULFILLED = 'TRANSFER_CLIENT_FULFILLED';
export const TRANSFER_CLIENT_REJECTED = 'TRANSFER_CLIENT_REJECTED';

export const ARCHIVE_CLIENT = 'ARCHIVE_CLIENT';
export const ARCHIVE_CLIENT_PENDING = 'ARCHIVE_CLIENT_PENDING';
export const ARCHIVE_CLIENT_FULFILLED = 'ARCHIVE_CLIENT_FULFILLED';
export const ARCHIVE_CLIENT_REJECTED = 'ARCHIVE_CLIENT_REJECTED';

export const GET_ARCHIVED_CLIENT = 'GET_ARCHIVED_CLIENT';
export const GET_ARCHIVED_CLIENT_PENDING = 'GET_ARCHIVED_CLIENT_PENDING';
export const GET_ARCHIVED_CLIENT_FULFILLED = 'GET_ARCHIVED_CLIENT_FULFILLED';
export const GET_ARCHIVED_CLIENT_REJECTED = 'GET_ARCHIVED_CLIENT_REJECTED';


/* postdischarge */
export const GET_POSTDISCHARGES_COUNT = 'GET_POSTDISCHARGES_COUNT';
export const GET_POSTDISCHARGES_COUNT_PENDING = 'GET_POSTDISCHARGES_COUNT_PENDING';
export const GET_POSTDISCHARGES_COUNT_FULFILLED = 'GET_POSTDISCHARGES_COUNT_FULFILLED';
export const GET_POSTDISCHARGES_COUNT_REJECTED = 'GET_POSTDISCHARGES_COUNT_REJECTED';

export const GET_POSTDISCHARGE = 'GET_POSTDISCHARGE';
export const GET_POSTDISCHARGE_PENDING = 'GET_POSTDISCHARGE_PENDING';
export const GET_POSTDISCHARGE_FULFILLED = 'GET_POSTDISCHARGE_FULFILLED';
export const GET_POSTDISCHARGE_REJECTED = 'GET_POSTDISCHARGE_REJECTED';

export const GET_POSTDISCHARGES_LIST = 'GET_POSTDISCHARGES_LIST';
export const GET_POSTDISCHARGES_LIST_PENDING = 'GET_POSTDISCHARGES_LIST_PENDING';
export const GET_POSTDISCHARGES_LIST_FULFILLED = 'GET_POSTDISCHARGES_LIST_FULFILLED';
export const GET_POSTDISCHARGES_LIST_REJECTED = 'GET_POSTDISCHARGES_LIST_REJECTED';

export const GET_POSTDISCHARGES_LIST_90D = 'GET_POSTDISCHARGES_LIST_90D';
export const GET_POSTDISCHARGES_LIST_90D_PENDING = 'GET_POSTDISCHARGES_LIST_90D_PENDING';
export const GET_POSTDISCHARGES_LIST_90D_FULFILLED = 'GET_POSTDISCHARGES_LIST_90D_FULFILLED';
export const GET_POSTDISCHARGES_LIST_90D_REJECTED = 'GET_POSTDISCHARGES_LIST_90D_REJECTED';

export const GET_POSTDISCHARGES_LIST_180D = 'GET_POSTDISCHARGES_LIST_180D';
export const GET_POSTDISCHARGES_LIST_180D_PENDING = 'GET_POSTDISCHARGES_LIST_180D_PENDING';
export const GET_POSTDISCHARGES_LIST_180D_FULFILLED = 'GET_POSTDISCHARGES_LIST_180D_FULFILLED';
export const GET_POSTDISCHARGES_LIST_180D_REJECTED = 'GET_POSTDISCHARGES_LIST_180D_REJECTED';

export const GET_POSTDISCHARGES_LIST_12M = 'GET_POSTDISCHARGES_LIST_12M';
export const GET_POSTDISCHARGES_LIST_12M_PENDING = 'GET_POSTDISCHARGES_LIST_12M_PENDING';
export const GET_POSTDISCHARGES_LIST_12M_FULFILLED = 'GET_POSTDISCHARGES_LIST_12M_FULFILLED';
export const GET_POSTDISCHARGES_LIST_12M_REJECTED = 'GET_POSTDISCHARGES_LIST_12M_REJECTED';

export const GET_POSTDISCHARGES_LIST_24M = 'GET_POSTDISCHARGES_LIST_24M';
export const GET_POSTDISCHARGES_LIST_24M_PENDING = 'GET_POSTDISCHARGES_LIST_24M_PENDING';
export const GET_POSTDISCHARGES_LIST_24M_FULFILLED = 'GET_POSTDISCHARGES_LIST_24M_FULFILLED';
export const GET_POSTDISCHARGES_LIST_24M_REJECTED = 'GET_POSTDISCHARGES_LIST_24M_REJECTED';

export const GET_POSTDISCHARGES_LIST_36M = 'GET_POSTDISCHARGES_LIST_36M';
export const GET_POSTDISCHARGES_LIST_36M_PENDING = 'GET_POSTDISCHARGES_LIST_36M_PENDING';
export const GET_POSTDISCHARGES_LIST_36M_FULFILLED = 'GET_POSTDISCHARGES_LIST_36M_FULFILLED';
export const GET_POSTDISCHARGES_LIST_36M_REJECTED = 'GET_POSTDISCHARGES_LIST_36M_REJECTED';

export const UPDATE_POSTDISCHARGE_SAVE = 'UPDATE_POSTDISCHARGE_SAVE';
export const UPDATE_POSTDISCHARGE_SAVE_PENDING = 'UPDATE_POSTDISCHARGE_SAVE_PENDING';
export const UPDATE_POSTDISCHARGE_SAVE_FULFILLED = 'UPDATE_POSTDISCHARGE_SAVE_FULFILLED';
export const UPDATE_POSTDISCHARGE_SAVE_REJECTED = 'UPDATE_POSTDISCHARGE_SAVE_REJECTED';

export const UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE = 'UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE';
export const UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_PENDING = 'UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_PENDING';
export const UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_FULFILLED = 'UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_FULFILLED';
export const UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_REJECTED = 'UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE_REJECTED';

export const ARCHIVE_POSTDISCHARGE = 'ARCHIVE_POSTDISCHARGE';
export const ARCHIVE_POSTDISCHARGE_PENDING = 'ARCHIVE_POSTDISCHARGE_PENDING';
export const ARCHIVE_POSTDISCHARGE_FULFILLED = 'ARCHIVE_POSTDISCHARGE_FULFILLED';
export const ARCHIVE_POSTDISCHARGE_REJECTED = 'ARCHIVE_POSTDISCHARGE_REJECTED';

export const GET_ARCHIVED_POSTDISCHARGE = 'GET_ARCHIVED_POSTDISCHARGE';
export const GET_ARCHIVED_POSTDISCHARGE_PENDING = 'GET_ARCHIVED_POSTDISCHARGE_PENDING';
export const GET_ARCHIVED_POSTDISCHARGE_FULFILLED = 'GET_ARCHIVED_POSTDISCHARGE_FULFILLED';
export const GET_ARCHIVED_POSTDISCHARGE_REJECTED = 'GET_ARCHIVED_POSTDISCHARGE_REJECTED';


/* Programs */
export const PROGRAMS_TABLE = 'programs';

export const GET_PROGRAM = 'GET_PROGRAM';
export const GET_PROGRAM_PENDING = 'GET_PROGRAM_PENDING';
export const GET_PROGRAM_FULFILLED = 'GET_PROGRAM_FULFILLED';
export const GET_PROGRAM_REJECTED = 'GET_PROGRAM_REJECTED';

export const GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST = 'GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST';
export const GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_PENDING = 'GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_PENDING';
export const GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_FULFILLED = 'GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_FULFILLED';
export const GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_REJECTED = 'GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_REJECTED';

export const GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST = 'GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST';
export const GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_PENDING = 'GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_PENDING';
export const GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED = 'GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED';
export const GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_REJECTED = 'GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_REJECTED';

export const GET_PROGRAMS_LIST = 'GET_PROGRAMS_LIST';
export const GET_PROGRAMS_LIST_PENDING = 'GET_PROGRAMS_LIST_PENDING';
export const GET_PROGRAMS_LIST_FULFILLED = 'GET_PROGRAMS_LIST_FULFILLED';
export const GET_PROGRAMS_LIST_REJECTED = 'GET_PROGRAMS_LIST_REJECTED';

                                                                                                        // export const DELETE_PROGRAM = 'DELETE_PROGRAM';
                                                                                                        // export const DELETE_PROGRAM_PENDING = 'DELETE_PROGRAM_PENDING';
                                                                                                        // export const DELETE_PROGRAM_FULFILLED = 'DELETE_PROGRAM_FULFILLED';
                                                                                                        // export const DELETE_PROGRAM_REJECTED = 'DELETE_PROGRAM_REJECTED';

                                                                                                        // export const ADD_PROGRAM = 'ADD_PROGRAM';
                                                                                                        // export const ADD_PROGRAM_PENDING = 'ADD_PROGRAM_PENDING';
                                                                                                        // export const ADD_PROGRAM_FULFILLED = 'ADD_PROGRAM_FULFILLED';
                                                                                                        // export const ADD_PROGRAM_REJECTED = 'ADD_PROGRAM_REJECTED';

                                                                                                        // export const UPDATE_PROGRAM = 'UPDATE_PROGRAM';
                                                                                                        // export const UPDATE_PROGRAM_PENDING = 'UPDATE_PROGRAM_PENDING';
                                                                                                        // export const UPDATE_PROGRAM_FULFILLED = 'UPDATE_PROGRAM_FULFILLED';
                                                                                                        // export const UPDATE_PROGRAM_REJECTED = 'UPDATE_PROGRAM_REJECTED';

/* Login Roles */
export const LOGINROLES_TABLE = 'loginroles';
export const GET_LOGINROLES_LIST = 'GET_LOGINROLES_LIST';
export const GET_LOGINROLES_LIST_PENDING = 'GET_LOGINROLES_LIST_PENDING';
export const GET_LOGINROLES_LIST_FULFILLED = 'GET_LOGINROLES_LIST_FULFILLED';
export const GET_LOGINROLES_LIST_REJECTED = 'GET_LOGINROLES_LIST_REJECTED';

export const GET_LOGINROLE = 'GET_LOGINROLE';
export const GET_LOGINROLE_PENDING = 'GET_LOGINROLE_PENDING';
export const GET_LOGINROLE_FULFILLED = 'GET_LOGINROLE_FULFILLED';
export const GET_LOGINROLE_REJECTED = 'GET_LOGINROLE_REJECTED';

                                                                                                        export const DELETE_LOGINROLE = 'DELETE_LOGINROLE';
                                                                                                        export const DELETE_LOGINROLE_PENDING = 'DELETE_LOGINROLE_PENDING';
                                                                                                        export const DELETE_LOGINROLE_FULFILLED = 'DELETE_LOGINROLE_FULFILLED';
                                                                                                        export const DELETE_LOGINROLE_REJECTED = 'DELETE_LOGINROLE_REJECTED';

                                                                                                        export const ADD_LOGINROLE = 'ADD_LOGINROLE';
                                                                                                        export const ADD_LOGINROLE_PENDING = 'ADD_LOGINROLE_PENDING';
                                                                                                        export const ADD_LOGINROLE_FULFILLED = 'ADD_LOGINROLE_FULFILLED';
                                                                                                        export const ADD_LOGINROLE_REJECTED = 'ADD_LOGINROLE_REJECTED';

                                                                                                        export const UPDATE_LOGINROLE = 'UPDATE_LOGINROLE';
                                                                                                        export const UPDATE_LOGINROLE_PENDING = 'UPDATE_LOGINROLE_PENDING';
                                                                                                        export const UPDATE_LOGINROLE_FULFILLED = 'UPDATE_LOGINROLE_FULFILLED';
                                                                                                        export const UPDATE_LOGINROLE_REJECTED = 'UPDATE_LOGINROLE_REJECTED';

/* INSTITUTIONS */
export const INSTITUTIONS_TABLE = 'institutions';
export const GET_INSTITUTIONS_LIST = 'GET_INSTITUTIONS_LIST';
export const GET_INSTITUTIONS_LIST_PENDING = 'GET_INSTITUTIONS_LIST_PENDING';
export const GET_INSTITUTIONS_LIST_FULFILLED = 'GET_INSTITUTIONS_LIST_FULFILLED';
export const GET_INSTITUTIONS_LIST_REJECTED = 'GET_INSTITUTIONS_LIST_REJECTED';

export const GET_INSTITUTION = 'GET_INSTITUTION';
export const GET_INSTITUTION_PENDING = 'GET_INSTITUTION_PENDING';
export const GET_INSTITUTION_FULFILLED = 'GET_INSTITUTION_FULFILLED';
export const GET_INSTITUTION_REJECTED = 'GET_INSTITUTION_REJECTED';

                                                                                                        export const DELETE_INSTITUTION = 'DELETE_INSTITUTION';
                                                                                                        export const DELETE_INSTITUTION_PENDING = 'DELETE_INSTITUTION_PENDING';
                                                                                                        export const DELETE_INSTITUTION_FULFILLED = 'DELETE_INSTITUTION_FULFILLED';
                                                                                                        export const DELETE_INSTITUTION_REJECTED = 'DELETE_INSTITUTION_REJECTED';

                                                                                                        export const ADD_INSTITUTION = 'ADD_INSTITUTION';
                                                                                                        export const ADD_INSTITUTION_PENDING = 'ADD_INSTITUTION_PENDING';
                                                                                                        export const ADD_INSTITUTION_FULFILLED = 'ADD_INSTITUTION_FULFILLED';
                                                                                                        export const ADD_INSTITUTION_REJECTED = 'ADD_INSTITUTION_REJECTED';

                                                                                                        export const UPDATE_INSTITUTION = 'UPDATE_INSTITUTION';
                                                                                                        export const UPDATE_INSTITUTION_PENDING = 'UPDATE_INSTITUTION_PENDING';
                                                                                                        export const UPDATE_INSTITUTION_FULFILLED = 'UPDATE_INSTITUTION_FULFILLED';
                                                                                                        export const UPDATE_INSTITUTION_REJECTED = 'UPDATE_INSTITUTION_REJECTED';

/* GANGAFFILIATIONS */
export const GANGAFFILIATIONS_TABLE = 'gangaffiliations';
export const GET_GANGAFFILIATIONS_LIST = 'GET_GANGAFFILIATIONS_LIST';
export const GET_GANGAFFILIATIONS_LIST_PENDING = 'GET_GANGAFFILIATIONS_LIST_PENDING';
export const GET_GANGAFFILIATIONS_LIST_FULFILLED = 'GET_GANGAFFILIATIONS_LIST_FULFILLED';
export const GET_GANGAFFILIATIONS_LIST_REJECTED = 'GET_GANGAFFILIATIONS_LIST_REJECTED';

export const GET_GANGAFFILIATION = 'GET_GANGAFFILIATION';
export const GET_GANGAFFILIATION_PENDING = 'GET_GANGAFFILIATION_PENDING';
export const GET_GANGAFFILIATION_FULFILLED = 'GET_GANGAFFILIATION_FULFILLED';
export const GET_GANGAFFILIATION_REJECTED = 'GET_GANGAFFILIATION_REJECTED';

                                                                                                        export const DELETE_GANGAFFILIATION = 'DELETE_GANGAFFILIATION';
                                                                                                        export const DELETE_GANGAFFILIATION_PENDING = 'DELETE_GANGAFFILIATION_PENDING';
                                                                                                        export const DELETE_GANGAFFILIATION_FULFILLED = 'DELETE_GANGAFFILIATION_FULFILLED';
                                                                                                        export const DELETE_GANGAFFILIATION_REJECTED = 'DELETE_GANGAFFILIATION_REJECTED';

                                                                                                        export const ADD_GANGAFFILIATION = 'ADD_GANGAFFILIATION';
                                                                                                        export const ADD_GANGAFFILIATION_PENDING = 'ADD_GANGAFFILIATION_PENDING';
                                                                                                        export const ADD_GANGAFFILIATION_FULFILLED = 'ADD_GANGAFFILIATION_FULFILLED';
                                                                                                        export const ADD_GANGAFFILIATION_REJECTED = 'ADD_GANGAFFILIATION_REJECTED';

                                                                                                        export const UPDATE_GANGAFFILIATION = 'UPDATE_GANGAFFILIATION';
                                                                                                        export const UPDATE_GANGAFFILIATION_PENDING = 'UPDATE_GANGAFFILIATION_PENDING';
                                                                                                        export const UPDATE_GANGAFFILIATION_FULFILLED = 'UPDATE_GANGAFFILIATION_FULFILLED';
                                                                                                        export const UPDATE_GANGAFFILIATION_REJECTED = 'UPDATE_GANGAFFILIATION_REJECTED';

/* BOPINSTITUTION */
export const BOPINSTITUTION_TABLE = 'bopinstitutions';
export const GET_BOPINSTITUTIONS_LIST = 'GET_BOPINSTITUTIONS_LIST';
export const GET_BOPINSTITUTIONS_LIST_PENDING = 'GET_BOPINSTITUTIONS_LIST_PENDING';
export const GET_BOPINSTITUTIONS_LIST_FULFILLED = 'GET_BOPINSTITUTIONS_LIST_FULFILLED';
export const GET_BOPINSTITUTIONS_LIST_REJECTED = 'GET_BOPINSTITUTIONS_LIST_REJECTED';

export const GET_BOPINSTITUTION = 'GET_BOPINSTITUTION';
export const GET_BOPINSTITUTION_PENDING = 'GET_BOPINSTITUTION_PENDING';
export const GET_BOPINSTITUTION_FULFILLED = 'GET_BOPINSTITUTION_FULFILLED';
export const GET_BOPINSTITUTION_REJECTED = 'GET_BOPINSTITUTION_REJECTED';

                                                                                                        export const DELETE_BOPINSTITUTION = 'DELETE_BOPINSTITUTION';
                                                                                                        export const DELETE_BOPINSTITUTION_PENDING = 'DELETE_BOPINSTITUTION_PENDING';
                                                                                                        export const DELETE_BOPINSTITUTION_FULFILLED = 'DELETE_BOPINSTITUTION_FULFILLED';
                                                                                                        export const DELETE_BOPINSTITUTION_REJECTED = 'DELETE_BOPINSTITUTION_REJECTED';

                                                                                                        export const ADD_BOPINSTITUTION = 'ADD_BOPINSTITUTION';
                                                                                                        export const ADD_BOPINSTITUTION_PENDING = 'ADD_BOPINSTITUTION_PENDING';
                                                                                                        export const ADD_BOPINSTITUTION_FULFILLED = 'ADD_BOPINSTITUTION_FULFILLED';
                                                                                                        export const ADD_BOPINSTITUTION_REJECTED = 'ADD_BOPINSTITUTION_REJECTED';

                                                                                                        export const UPDATE_BOPINSTITUTION = 'UPDATE_BOPINSTITUTION';
                                                                                                        export const UPDATE_BOPINSTITUTION_PENDING = 'UPDATE_BOPINSTITUTION_PENDING';
                                                                                                        export const UPDATE_BOPINSTITUTION_FULFILLED = 'UPDATE_BOPINSTITUTION_FULFILLED';
                                                                                                        export const UPDATE_BOPINSTITUTION_REJECTED = 'UPDATE_BOPINSTITUTION_REJECTED';

/* ReferralSources */
export const REFERRALSOURCE_TABLE = 'referralsources';
export const GET_REFERRALSOURCE_LIST = 'GET_REFERRALSOURCE_LIST';
export const GET_REFERRALSOURCE_LIST_PENDING = 'GET_REFERRALSOURCE_LIST_PENDING';
export const GET_REFERRALSOURCE_LIST_FULFILLED = 'GET_REFERRALSOURCE_LIST_FULFILLED';
export const GET_REFERRALSOURCE_LIST_REJECTED = 'GET_REFERRALSOURCE_LIST_REJECTED';

export const GET_REFERRALSOURCE = 'GET_REFERRALSOURCE';
export const GET_REFERRALSOURCE_PENDING = 'GET_REFERRALSOURCE_PENDING';
export const GET_REFERRALSOURCE_FULFILLED = 'GET_REFERRALSOURCE_FULFILLED';
export const GET_REFERRALSOURCE_REJECTED = 'GET_REFERRALSOURCE_REJECTED';

                                                                                                        export const DELETE_REFERRALSOURCE = 'DELETE_REFERRALSOURCE';
                                                                                                        export const DELETE_REFERRALSOURCE_PENDING = 'DELETE_REFERRALSOURCE_PENDING';
                                                                                                        export const DELETE_REFERRALSOURCE_FULFILLED = 'DELETE_REFERRALSOURCE_FULFILLED';
                                                                                                        export const DELETE_REFERRALSOURCE_REJECTED = 'DELETE_REFERRALSOURCE_REJECTED';

                                                                                                        export const ADD_REFERRALSOURCE = 'ADD_REFERRALSOURCE';
                                                                                                        export const ADD_REFERRALSOURCE_PENDING = 'ADD_REFERRALSOURCE_PENDING';
                                                                                                        export const ADD_REFERRALSOURCE_FULFILLED = 'ADD_REFERRALSOURCE_FULFILLED';
                                                                                                        export const ADD_REFERRALSOURCE_REJECTED = 'ADD_REFERRALSOURCE_REJECTED';

                                                                                                        export const UPDATE_REFERRALSOURCE = 'UPDATE_REFERRALSOURCE';
                                                                                                        export const UPDATE_REFERRALSOURCE_PENDING = 'UPDATE_REFERRALSOURCE_PENDING';
                                                                                                        export const UPDATE_REFERRALSOURCE_FULFILLED = 'UPDATE_REFERRALSOURCE_FULFILLED';
                                                                                                        export const UPDATE_REFERRALSOURCE_REJECTED = 'UPDATE_REFERRALSOURCE_REJECTED';

/* ReferralOutcomes */
export const REFERRALOUTCOME_TABLE = 'referraloutcomes';
export const GET_REFERRALOUTCOME_LIST = 'GET_REFERRALOUTCOME_LIST';
export const GET_REFERRALOUTCOME_LIST_PENDING = 'GET_REFERRALOUTCOME_LIST_PENDING';
export const GET_REFERRALOUTCOME_LIST_FULFILLED = 'GET_REFERRALOUTCOME_LIST_FULFILLED';
export const GET_REFERRALOUTCOME_LIST_REJECTED = 'GET_REFERRALOUTCOME_LIST_REJECTED';

/* ClientOutcomes */
export const CLIENTOUTCOME_TABLE = 'clientoutcomes';
export const GET_CLIENTOUTCOME_LIST = 'GET_CLIENTOUTCOME_LIST';
export const GET_CLIENTOUTCOME_LIST_PENDING = 'GET_CLIENTOUTCOME_LIST_PENDING';
export const GET_CLIENTOUTCOME_LIST_FULFILLED = 'GET_CLIENTOUTCOME_LIST_FULFILLED';
export const GET_CLIENTOUTCOME_LIST_REJECTED = 'GET_CLIENTOUTCOME_LIST_REJECTED';

/* LevelsOfSecurity */
export const LEVELSOFSECURITY_TABLE = 'levelsofsecurities';
export const GET_LEVELSOFSECURITY_LIST = 'GET_LEVELSOFSECURITY_LIST';
export const GET_LEVELSOFSECURITY_LIST_PENDING = 'GET_LEVELSOFSECURITY_LIST_PENDING';
export const GET_LEVELSOFSECURITY_LIST_FULFILLED = 'GET_LEVELSOFSECURITY_LIST_FULFILLED';
export const GET_LEVELSOFSECURITY_LIST_REJECTED = 'GET_LEVELSOFSECURITY_LIST_REJECTED';

export const GET_LEVELSOFSECURITY = 'GET_LEVELSOFSECURITY';
export const GET_LEVELSOFSECURITY_PENDING = 'GET_LEVELSOFSECURITY_PENDING';
export const GET_LEVELSOFSECURITY_FULFILLED = 'GET_LEVELSOFSECURITY_FULFILLED';
export const GET_LEVELSOFSECURITY_REJECTED = 'GET_LEVELSOFSECURITY_REJECTED';

                                                                                                                        export const DELETE_LEVELSOFSECURITY = 'DELETE_LEVELSOFSECURITY';
                                                                                                                        export const DELETE_LEVELSOFSECURITY_PENDING = 'DELETE_LEVELSOFSECURITY_PENDING';
                                                                                                                        export const DELETE_LEVELSOFSECURITY_FULFILLED = 'DELETE_LEVELSOFSECURITY_FULFILLED';
                                                                                                                        export const DELETE_LEVELSOFSECURITY_REJECTED = 'DELETE_LEVELSOFSECURITY_REJECTED';

                                                                                                                        export const ADD_LEVELSOFSECURITY = 'ADD_LEVELSOFSECURITY';
                                                                                                                        export const ADD_LEVELSOFSECURITY_PENDING = 'ADD_LEVELSOFSECURITY_PENDING';
                                                                                                                        export const ADD_LEVELSOFSECURITY_FULFILLED = 'ADD_LEVELSOFSECURITY_FULFILLED';
                                                                                                                        export const ADD_LEVELSOFSECURITY_REJECTED = 'ADD_LEVELSOFSECURITY_REJECTED';

                                                                                                                        export const UPDATE_LEVELSOFSECURITY = 'UPDATE_LEVELSOFSECURITY';
                                                                                                                        export const UPDATE_LEVELSOFSECURITY_PENDING = 'UPDATE_LEVELSOFSECURITY_PENDING';
                                                                                                                        export const UPDATE_LEVELSOFSECURITY_FULFILLED = 'UPDATE_LEVELSOFSECURITY_FULFILLED';
                                                                                                                        export const UPDATE_LEVELSOFSECURITY_REJECTED = 'UPDATE_LEVELSOFSECURITY_REJECTED';










                                                                                                                        
















/*** refactor and delete all this may no longer be needed - start */

/* AlchoholAftercarePrograms */
export const ALCOHOLAFTERCAREPROGRAMS_TABLE = 'alchoholaftercareprograms';
export const GET_ALCOHOLAFTERCAREPROGRAMS_LIST = 'GET_ALCOHOLAFTERCAREPROGRAMS_LIST';
export const GET_ALCOHOLAFTERCAREPROGRAMS_LIST_PENDING = 'GET_ALCOHOLAFTERCAREPROGRAMS_LIST_PENDING';
export const GET_ALCOHOLAFTERCAREPROGRAMS_LIST_FULFILLED = 'GET_ALCOHOLAFTERCAREPROGRAMS_LIST_FULFILLED';
export const GET_ALCOHOLAFTERCAREPROGRAMS_LIST_REJECTED = 'GET_ALCOHOLAFTERCAREPROGRAMS_LIST_REJECTED';

export const GET_ALCOHOLAFTERCAREPROGRAM = 'GET_ALCOHOLAFTERCAREPROGRAM';
export const GET_ALCOHOLAFTERCAREPROGRAM_PENDING = 'GET_ALCOHOLAFTERCAREPROGRAM_PENDING';
export const GET_ALCOHOLAFTERCAREPROGRAM_FULFILLED = 'GET_ALCOHOLAFTERCAREPROGRAM_FULFILLED';
export const GET_ALCOHOLAFTERCAREPROGRAM_REJECTED = 'GET_ALCOHOLAFTERCAREPROGRAM_REJECTED';

                                                                                                        export const DELETE_ALCOHOLAFTERCAREPROGRAM = 'DELETE_ALCOHOLAFTERCAREPROGRAM';
                                                                                                        export const DELETE_ALCOHOLAFTERCAREPROGRAM_PENDING = 'DELETE_ALCOHOLAFTERCAREPROGRAM_PENDING';
                                                                                                        export const DELETE_ALCOHOLAFTERCAREPROGRAM_FULFILLED = 'DELETE_ALCOHOLAFTERCAREPROGRAM_FULFILLED';
                                                                                                        export const DELETE_ALCOHOLAFTERCAREPROGRAM_REJECTED = 'DELETE_ALCOHOLAFTERCAREPROGRAM_REJECTED';

                                                                                                        export const ADD_ALCOHOLAFTERCAREPROGRAM = 'ADD_ALCOHOLAFTERCAREPROGRAM';
                                                                                                        export const ADD_ALCOHOLAFTERCAREPROGRAM_PENDING = 'ADD_ALCOHOLAFTERCAREPROGRAM_PENDING';
                                                                                                        export const ADD_ALCOHOLAFTERCAREPROGRAM_FULFILLED = 'ADD_ALCOHOLAFTERCAREPROGRAM_FULFILLED';
                                                                                                        export const ADD_ALCOHOLAFTERCAREPROGRAM_REJECTED = 'ADD_ALCOHOLAFTERCAREPROGRAM_REJECTED';

                                                                                                        export const UPDATE_ALCOHOLAFTERCAREPROGRAM = 'UPDATE_ALCOHOLAFTERCAREPROGRAM';
                                                                                                        export const UPDATE_ALCOHOLAFTERCAREPROGRAM_PENDING = 'UPDATE_ALCOHOLAFTERCAREPROGRAM_PENDING';
                                                                                                        export const UPDATE_ALCOHOLAFTERCAREPROGRAM_FULFILLED = 'UPDATE_ALCOHOLAFTERCAREPROGRAM_FULFILLED';
                                                                                                        export const UPDATE_ALCOHOLAFTERCAREPROGRAM_REJECTED = 'UPDATE_ALCOHOLAFTERCAREPROGRAM_REJECTED';



/* BHTsINSURANCEPROVIDERS */
export const BHTsINSURANCEPROVIDERS_TABLE = 'bhtsinsuranceproviders';
export const GET_BHTsINSURANCEPROVIDERS_LIST = 'GET_BHTsINSURANCEPROVIDERS_LIST';
export const GET_BHTsINSURANCEPROVIDERS_LIST_PENDING = 'GET_BHTsINSURANCEPROVIDERS_LIST_PENDING';
export const GET_BHTsINSURANCEPROVIDERS_LIST_FULFILLED = 'GET_BHTsINSURANCEPROVIDERS_LIST_FULFILLED';
export const GET_BHTsINSURANCEPROVIDERS_LIST_REJECTED = 'GET_BHTsINSURANCEPROVIDERS_LIST_REJECTED';

export const GET_BHTsINSURANCEPROVIDER = 'GET_BHTsINSURANCEPROVIDER';
export const GET_BHTsINSURANCEPROVIDER_PENDING = 'GET_BHTsINSURANCEPROVIDER_PENDING';
export const GET_BHTsINSURANCEPROVIDER_FULFILLED = 'GET_BHTsINSURANCEPROVIDER_FULFILLED';
export const GET_BHTsINSURANCEPROVIDER_REJECTED = 'GET_BHTsINSURANCEPROVIDER_REJECTED';

                                                                                                        export const DELETE_BHTsINSURANCEPROVIDER = 'DELETE_BHTsINSURANCEPROVIDER';
                                                                                                        export const DELETE_BHTsINSURANCEPROVIDER_PENDING = 'DELETE_BHTsINSURANCEPROVIDER_PENDING';
                                                                                                        export const DELETE_BHTsINSURANCEPROVIDER_FULFILLED = 'DELETE_BHTsINSURANCEPROVIDER_FULFILLED';
                                                                                                        export const DELETE_BHTsINSURANCEPROVIDER_REJECTED = 'DELETE_BHTsINSURANCEPROVIDER_REJECTED';

                                                                                                        export const ADD_BHTsINSURANCEPROVIDER = 'ADD_BHTsINSURANCEPROVIDER';
                                                                                                        export const ADD_BHTsINSURANCEPROVIDER_PENDING = 'ADD_BHTsINSURANCEPROVIDER_PENDING';
                                                                                                        export const ADD_BHTsINSURANCEPROVIDER_FULFILLED = 'ADD_BHTsINSURANCEPROVIDER_FULFILLED';
                                                                                                        export const ADD_BHTsINSURANCEPROVIDER_REJECTED = 'ADD_BHTsINSURANCEPROVIDER_REJECTED';

                                                                                                        export const UPDATE_BHTsINSURANCEPROVIDER = 'UPDATE_BHTsINSURANCEPROVIDER';
                                                                                                        export const UPDATE_BHTsINSURANCEPROVIDER_PENDING = 'UPDATE_BHTsINSURANCEPROVIDER_PENDING';
                                                                                                        export const UPDATE_BHTsINSURANCEPROVIDER_FULFILLED = 'UPDATE_BHTsINSURANCEPROVIDER_FULFILLED';
                                                                                                        export const UPDATE_BHTsINSURANCEPROVIDER_REJECTED = 'UPDATE_BHTsINSURANCEPROVIDER_REJECTED';


/* DrugAftercareProgram */
export const DRUGAFTERCAREPROGRAMS_TABLE = 'drugaftercareprograms';
export const GET_DRUGAFTERCAREPROGRAMS_LIST = 'GET_DRUGAFTERCAREPROGRAMS_LIST';
export const GET_DRUGAFTERCAREPROGRAMS_LIST_PENDING = 'GET_DRUGAFTERCAREPROGRAMS_LIST_PENDING';
export const GET_DRUGAFTERCAREPROGRAMS_LIST_FULFILLED = 'GET_DRUGAFTERCAREPROGRAMS_LIST_FULFILLED';
export const GET_DRUGAFTERCAREPROGRAMS_LIST_REJECTED = 'GET_DRUGAFTERCAREPROGRAMS_LIST_REJECTED';

export const GET_DRUGAFTERCAREPROGRAM = 'GET_DRUGAFTERCAREPROGRAM';
export const GET_DRUGAFTERCAREPROGRAM_PENDING = 'GET_DRUGAFTERCAREPROGRAM_PENDING';
export const GET_DRUGAFTERCAREPROGRAM_FULFILLED = 'GET_DRUGAFTERCAREPROGRAM_FULFILLED';
export const GET_DRUGAFTERCAREPROGRAM_REJECTED = 'GET_DRUGAFTERCAREPROGRAM_REJECTED';

                                                                                                                        export const DELETE_DRUGAFTERCAREPROGRAM = 'DELETE_DRUGAFTERCAREPROGRAM';
                                                                                                                        export const DELETE_DRUGAFTERCAREPROGRAM_PENDING = 'DELETE_DRUGAFTERCAREPROGRAM_PENDING';
                                                                                                                        export const DELETE_DRUGAFTERCAREPROGRAM_FULFILLED = 'DELETE_DRUGAFTERCAREPROGRAM_FULFILLED';
                                                                                                                        export const DELETE_DRUGAFTERCAREPROGRAM_REJECTED = 'DELETE_DRUGAFTERCAREPROGRAM_REJECTED';

                                                                                                                        export const ADD_DRUGAFTERCAREPROGRAM = 'ADD_DRUGAFTERCAREPROGRAM';
                                                                                                                        export const ADD_DRUGAFTERCAREPROGRAM_PENDING = 'ADD_DRUGAFTERCAREPROGRAM_PENDING';
                                                                                                                        export const ADD_DRUGAFTERCAREPROGRAM_FULFILLED = 'ADD_DRUGAFTERCAREPROGRAM_FULFILLED';
                                                                                                                        export const ADD_DRUGAFTERCAREPROGRAM_REJECTED = 'ADD_DRUGAFTERCAREPROGRAM_REJECTED';

                                                                                                                        export const UPDATE_DRUGAFTERCAREPROGRAM = 'UPDATE_DRUGAFTERCAREPROGRAM';
                                                                                                                        export const UPDATE_DRUGAFTERCAREPROGRAM_PENDING = 'UPDATE_DRUGAFTERCAREPROGRAM_PENDING';
                                                                                                                        export const UPDATE_DRUGAFTERCAREPROGRAM_FULFILLED = 'UPDATE_DRUGAFTERCAREPROGRAM_FULFILLED';
                                                                                                                        export const UPDATE_DRUGAFTERCAREPROGRAM_REJECTED = 'UPDATE_DRUGAFTERCAREPROGRAM_REJECTED';




/* FINANCIALRESPONSIBILITYPROGRAM */
export const FINANCIALRESPONSIBILITYPROGRAM_TABLE = 'financialresponsibilityprograms';
export const GET_FINANCIALRESPONSIBILITYPROGRAM_LIST = 'GET_FINANCIALRESPONSIBILITYPROGRAM_LIST';
export const GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_PENDING = 'GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_PENDING';
export const GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_FULFILLED = 'GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_FULFILLED';
export const GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_REJECTED = 'GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_REJECTED';

export const GET_FINANCIALRESPONSIBILITYPROGRAM = 'GET_FINANCIALRESPONSIBILITYPROGRAM';
export const GET_FINANCIALRESPONSIBILITYPROGRAM_PENDING = 'GET_FINANCIALRESPONSIBILITYPROGRAM_PENDING';
export const GET_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED = 'GET_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED';
export const GET_FINANCIALRESPONSIBILITYPROGRAM_REJECTED = 'GET_FINANCIALRESPONSIBILITYPROGRAM_REJECTED';

                                                                                                        export const DELETE_FINANCIALRESPONSIBILITYPROGRAM = 'DELETE_FINANCIALRESPONSIBILITYPROGRAM';
                                                                                                        export const DELETE_FINANCIALRESPONSIBILITYPROGRAM_PENDING = 'DELETE_FINANCIALRESPONSIBILITYPROGRAM_PENDING';
                                                                                                        export const DELETE_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED = 'DELETE_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED';
                                                                                                        export const DELETE_FINANCIALRESPONSIBILITYPROGRAM_REJECTED = 'DELETE_FINANCIALRESPONSIBILITYPROGRAM_REJECTED';

                                                                                                        export const ADD_FINANCIALRESPONSIBILITYPROGRAM = 'ADD_FINANCIALRESPONSIBILITYPROGRAM';
                                                                                                        export const ADD_FINANCIALRESPONSIBILITYPROGRAM_PENDING = 'ADD_FINANCIALRESPONSIBILITYPROGRAM_PENDING';
                                                                                                        export const ADD_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED = 'ADD_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED';
                                                                                                        export const ADD_FINANCIALRESPONSIBILITYPROGRAM_REJECTED = 'ADD_FINANCIALRESPONSIBILITYPROGRAM_REJECTED';

                                                                                                        export const UPDATE_FINANCIALRESPONSIBILITYPROGRAM = 'UPDATE_FINANCIALRESPONSIBILITYPROGRAM';
                                                                                                        export const UPDATE_FINANCIALRESPONSIBILITYPROGRAM_PENDING = 'UPDATE_FINANCIALRESPONSIBILITYPROGRAM_PENDING';
                                                                                                        export const UPDATE_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED = 'UPDATE_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED';
                                                                                                        export const UPDATE_FINANCIALRESPONSIBILITYPROGRAM_REJECTED = 'UPDATE_FINANCIALRESPONSIBILITYPROGRAM_REJECTED';

